import * as React from "react";

export const Ellipsis: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="4"
    fill="none"
    viewBox="0 0 12 4"
    {...props}
  >
    <path
      fill="#23252A"
      d="M10.255 3.125a1.125 1.125 0 1 0-.01-2.25 1.125 1.125 0 0 0 .01 2.25"
    ></path>
    <path
      fill="#23252A"
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M6.375 2.006a.37.37 0 0 1-.37.369.375.375 0 1 1 .37-.375zM2.125 2.006a.37.37 0 0 1-.37.369.375.375 0 1 1 .37-.375z"
    ></path>
  </svg>
);
